// Local Deps
import { makeGraphQLRequest } from '../utils/requestUtils';

export async function toolingById(id) {
  console.log("toolingById graphql", id)
  const query = `query toolingById(
    $id: ID!
    ) {
      toolingById(id: $id) {
          item {
              id, 
              niin
              cage
              description, 
              designAlloy, 
              toolingRef, 
              comments
              ownerCage
              partNum
              accessLevel
              category
          }
      }
    }`;

  // errors { message }
  const variables = { id };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function inventoryById(id) {
  console.log("inventoryById graphql", id)
  const query = `query inventoryById(
    $id: ID!
    ) {
      inventoryById(id: $id) {
          item {
              id, 
              niin
              cage
              description, 
              partNum
              price
              ui
              qup
              soh
              visibility
          }
      }
    }`;

  // errors { message }
  const variables = { id };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function deleteItem(id, modifiedBy, searchType) {
  const query = `mutation deleteItem(
    $id: ID!, 
    $modifiedBy: String!,
    $searchType: String!,
  ) {
    deleteItem(id:$id, modifiedBy:$modifiedBy, searchType:$searchType)
      {
      status
      }
    }`;

  // Variables
  const variables = { id, modifiedBy, searchType };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getInventoryManagementList(cage, offset, pageSize, sorted, filtered) {
  const searchType = "I"
  console.log("getInventoryManagementList graphql", cage, offset, pageSize, searchType, sorted, filtered)
  const query = `query inventorySearch(
    $cage: String
    $offset: Int
    $pageSize: Int
    $searchType: String
    $sorted: [SortOrder]
    $filtered: [Filter]
    ) {
      inventorySearch(cage: $cage, offset: $offset, pageSize: $pageSize, searchType: $searchType, sorted: $sorted, filtered: $filtered) {
          hits
          itemList {
              id, 
              niin
              partNum
              description
              price
              ui
              qup
              soh
              visibility
          }
      }
    }`;

  // errors { message }
  const variables = { cage, offset, pageSize, searchType, sorted, filtered };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function getToolingManagementList(cage, offset, pageSize, sorted, filtered) {
  const searchType = "T"
  console.log("getToolingManagementList graphql", cage, offset, pageSize, searchType, sorted, filtered)
  const query = `query toolingSearch(
    $cage: String
    $offset: Int
    $pageSize: Int
    $searchType: String
    $sorted: [SortOrder]
    $filtered: [Filter]
    ) {
      toolingSearch(cage: $cage, offset: $offset, pageSize: $pageSize, searchType: $searchType, sorted: $sorted, filtered: $filtered) {
          hits
          itemList {
              id, 
              niin
              cage
              description 
              designAlloy 
              toolingRef 
              comments
              ownerCage
              partNum
              accessLevel
              category
          }
      }
    }`;

  // errors { message }
  const variables = { cage, offset, pageSize, searchType, sorted, filtered };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function getToolingLocationsList(cage, offset, pageSize, sorted, filtered) {
  const searchType = "S"
  console.log("itemsSearch graphql", cage, offset, pageSize, searchType, sorted, filtered)
  const query = `query itemsSearch(
    $cage: String
    $offset: Int
    $pageSize: Int
    $searchType: String
    $sorted: [SortOrder]
    $filtered: [Filter]
    ) {
       itemsSearch(cage: $cage, offset: $offset, pageSize: $pageSize, searchType: $searchType, sorted: $sorted, filtered: $filtered) {
          hits
          itemList {
            id
            niin
            description
            cage
            partNum
            toolLocation
            category
            wsdc
            accessLevel
            govComment  
            soh  
          }
          errors {
            message
          }
        }
      
    }`;

  // errors { message }
  const variables = { cage, offset, pageSize, searchType, sorted, filtered };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function ninnsAndNsnsByCage(cage) {
  console.log("ninnsAndNsnsByCage graphql", cage)
  const query = `query ninnsAndNsnsByCage(
    $cage: String
    ) {
      ninnsAndNsnsByCage(cage: $cage) {
          niinsList 
          nsnsList
      }
    }`;

  // errors { message }
  const variables = { cage };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function masterLookupForItem({
  cage,
  partNum,
  niin,
  searchType,
}) {
  // Format Mutation
  const query = `mutation masterLookupItem(
    $cage: String,
    $partNum: String,
    $niin: String,
    $searchType: String
  ) {
    masterLookupItem(cage:$cage, partNum: $partNum, niin: $niin, searchType: $searchType )
      {
        isInventoryExist
        isToolingExist
        isNsnValid
        inventoryManagementData {
          id
          cage
          partNum
          niin
          description
          comments
          modifiedBy
          masterTblRecInserted
        }
        toolingManagementData {
          id
          cage
          partNum
          niin
          description
          comments
          modifiedBy
          masterTblRecInserted
        }
      }
    }`;

  // Variables
  const variables = {
    cage,
    partNum,
    niin,
    searchType
  };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}



// WEBPACK FOOTER //
// ./src/graphql/item.js